import { gql } from '@apollo/client'
import { useContext } from 'react'

import { BoxLockContext } from '../context'
import { ModalLock } from '../modal-lock'
import { PaywallLock } from '../paywall-lock'
import {
  CustomPlanLock_OfferLockDataFragment,
  CustomPlanLock_ViewerFragment,
} from './__generated__/custom-plan-lock.graphql'
import styles from './custom-plan-lock.module.scss'
import { CustomPlanLockContent } from './custom-plan-lock-content'

export interface CustomPlanLockProps {
  offerLockData: CustomPlanLock_OfferLockDataFragment
  viewer: CustomPlanLock_ViewerFragment
}

export function CustomPlanLock({ offerLockData, viewer }: CustomPlanLockProps) {
  const { componentType } = useContext(BoxLockContext)

  const content = <CustomPlanLockContent viewer={viewer} offerLockData={offerLockData} />

  switch (componentType) {
    case 'paywall':
      return (
        <PaywallLock offerLockData={offerLockData} className={styles.paywallCustomPlanLock}>
          {content}
        </PaywallLock>
      )
    case 'modal':
      return <ModalLock offerLockBody={offerLockData.body}>{content}</ModalLock>
    default:
      return null
  }
}

CustomPlanLock.fragments = {
  offerLockData: gql`
    fragment CustomPlanLock_offerLockData on OfferLockData {
      ...CustomPlanLockContent_offerLockData
      ...PaywallLock_offerLockData
      body {
        ...ModalLock_offerLockBody
      }
    }
    ${ModalLock.fragments.offerLockBody}
    ${PaywallLock.fragments.offerLockData}
    ${CustomPlanLockContent.fragments.offerLockData}
  `,
  viewer: gql`
    fragment CustomPlanLock_viewer on Profile {
      ...CustomPlanLockContent_viewer
    }
    ${CustomPlanLockContent.fragments.viewer}
  `,
}
